import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  .cards {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    .card {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      font-size: 14px;
      margin: 0 30px 30px 0;
      border: 1px solid ${props => props.theme.palette.general.greyLight};
      ${bp('sm')`
        width: calc(100% - 40px);
        margin: 0 auto 20px;
      `}

      .address {
        p {
          margin: 0;

          &:nth-child(1) {
            margin-bottom: 1em;
          }
        }
      }

      .actions {
        box-sizing: border-box;
        text-align: right;

        button {
          height: 30px;
          margin: 0 2px;

          &[disabled] {
            background: none;
            opacity: 0.8;

            > div {
              color: ${props => props.theme.palette.general.greyDark};

              :hover {
                color: ${props => props.theme.palette.general.greyDark};
              }
            }
          }

          > div {
            color: ${props => props.theme.palette.primary.alphaDark};
            font-weight: 600;
          }

          :hover {
            &:not([disabled]) {
              border-color: ${props => props.theme.palette.primary.alpha};

              > div {
                color: ${props => props.theme.palette.primary.alpha};
              }
            }
          }
        }
      }
    }

    .new-card {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
  }
`
